import { useMediaQuery } from "@mui/material";

export const useMobile = () => {
  return !useMediaQuery((theme) => theme.breakpoints.up("desktop"));
};
